module.exports = __webpack_public_path__ + "static/media/volume.1392db86.svg";